// extracted by mini-css-extract-plugin
export default {"treeWrapper":"FlatTreeMavenir_treeWrapper__6MRtr","container":"FlatTreeMavenir_container__m8ePw","treeFrame":"FlatTreeMavenir_treeFrame__szwmB"};